<template>
  <section class="section--pt-xlg section--sp-pt-lg _pb-sm">
    <div class="inner">
      <h2 class="Head__blue">
        「後でみる」をしたMELON TV
      </h2>
    </div>
    <div v-if="listMelonTV.length == 0" class="Card__class_archives _error">
      <div class="Error__box_class_tv inner">
        <div class="Error__box Error__box_class">
          <p class="Error__box_tx">
            ホーム画面でMELON TVをタップし「後で見る」にチェックを入れると、ここに表示されます。
          </p>
        </div>
      </div>
    </div>
    <div v-else class="Card__class_archives">
      <div
        class="Card__inner Card__class__inner Card__archives__inner inner swiper-container mySwiper ft_en"
      >
        <swiper v-if="isMobile" ref="swiper" :options="swiperOption" class="Card__area Card__archives_area Card__class_area swiper">
          <swiper-slide
            v-for="(scheduleClassOfDate) of listMelonTV"
            :id="`date-${scheduleClassOfDate.learning_day}`"
            :key="scheduleClassOfDate.id"
          >
            <div
              :class="`swiper-slide Card__box_list ${scheduleClassOfDate.is_new_date ? 'Card__date' : ''}`"
            >
              <div class="Card__date_area">
                <div class="Card__date_box">
                  <span class="Card__date_box_tx">
                    {{ showDate(scheduleClassOfDate.learning_day) }}
                  </span>
                  <span class="Card__day_tx_sub">&#040;{{ showDay(scheduleClassOfDate.learning_day) }}&#041;</span>
                </div>
              </div>
              <div class="Card__box_top">
                <div class="Card__box_time">
                  {{ scheduleClassOfDate.learning_time }}
                </div>
                <div class="Label Label__time">
                  {{ scheduleClassOfDate.time }} min
                </div>
              </div>
              <div
                class="Card__box Card__class_box"
                data-modal-open="class01"
                :style="parseCssVars(scheduleClassOfDate.master_program_category)"
                @click="openModalSchedule(scheduleClassOfDate.id)"
              >
                <div class="Card__box_label Card__box_label_secondary">
                  <div
                    class="
                          Label Label__time
                          Card__class_box_time_label_secondary
                          Card__box_time_label_secondary
                        "
                  >
                    {{ scheduleClassOfDate.time }} min
                  </div>
                  <span class="Card__box_label_class">
                    {{ scheduleClassOfDate.title }}
                  </span>
                  <span class="Card__box_label_name">
                    {{ scheduleClassOfDate.master_instructor.name }}
                  </span>
                  <div class="Card__box_label_schedule">
                    <div class="Card__box_label_schedule_date">
                      {{ showDate(scheduleClassOfDate.date) }}
                    </div>
                    <div class="Card__box_label_schedule_time">
                      {{ scheduleClassOfDate.learning_time }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div v-else class="Card__area Card__archives_area swiper-wrapper Card__class_area">
          <div
            v-for="(scheduleClassOfDate) of listMelonTV"
            :id="`date-${scheduleClassOfDate.learning_day}`"
            :key="scheduleClassOfDate.id"
            :class="`swiper-slide Card__box_list ${scheduleClassOfDate.is_new_date ? 'Card__date' : ''}`"
          >
            <div class="Card__date_area">
              <div class="Card__date_box">
                <span class="Card__date_box_tx">
                  {{ showDate(scheduleClassOfDate.learning_day) }}
                </span>
                <span class="Card__day_tx_sub">&#040;{{ showDay(scheduleClassOfDate.learning_day) }}&#041;</span>
              </div>
            </div>
            <div class="Card__box_top">
              <div class="Card__box_time">
                {{ scheduleClassOfDate.learning_time }}
              </div>
              <div class="Label Label__time">
                {{ scheduleClassOfDate.time }} min
              </div>
            </div>
            <div
              class="Card__box Card__class_box"
              data-modal-open="class01"
              :style="parseCssVars(scheduleClassOfDate.master_program_category)"
              @click="openModalSchedule(scheduleClassOfDate.id)"
            >
              <div class="Card__box_label Card__box_label_secondary">
                <div
                  class="
                      Label Label__time
                      Card__class_box_time_label_secondary
                      Card__box_time_label_secondary
                    "
                >
                  {{ scheduleClassOfDate.time }} min
                </div>
                <span class="Card__box_label_class">
                  {{ scheduleClassOfDate.master_program_category.name }}
                </span>
                <span class="Card__box_label_name">
                  {{ scheduleClassOfDate.master_instructor.name }}
                </span>
                <div class="Card__box_label_schedule">
                  <div class="Card__box_label_schedule_date">
                    {{ showDate(scheduleClassOfDate.date) }}
                  </div>
                  <div class="Card__box_label_schedule_time">
                    {{ scheduleClassOfDate.learning_time }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'
import melontvlaterService from '@/services/melontvlaterService'
import moment from 'moment'
import { parseCssVars } from '@/helpers/programCategory'
export default {
  name: 'ClassMelontv',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      isModalMelonTV: false,
      listMelonTV: {},
      isMobile: false,
      swiperOption: {
        slidesPerView: 2,
        centeredSlides: true,
        spaceBetween: 20,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 3,
            spaceBetween: 30
          }
        }
      },
      width: 0,
      height: 0
    }
  },
  async mounted() {
    this.getListMelonTVLater()
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    openModal() {
      console.log('ok')
    },
    handleResize() {
      this.width = window.innerWidth
      this.height = window.innerHeight
      if (this.width <= 767) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    handleListClasses(list) {
      const listDate = []
      const listMelonLater = []
      let currentListDate = null
      list.forEach(function(item, key) {
        if (item.melontv_management !== null) {
          listMelonLater.push(item)
        }
      })
      listMelonLater.sort(function(a, b) {
        return a.melontv_management.date.localeCompare(b.melontv_management.date)
      })
      listMelonLater.forEach(function(item, key) {
        let isNewDate = false
        if (item.melontv_management.date !== null) {
          if (!currentListDate || currentListDate !== item.melontv_management.learning_day) {
            currentListDate = item.melontv_management.learning_day
            isNewDate = true
          }
          const itemClass = item.melontv_management
          itemClass.is_new_date = isNewDate
          listDate.push(itemClass)
        }
      })
      this.listMelonTV = listDate
    },
    async getListMelonTVLater() {
      const response = await melontvlaterService.index()
      this.handleListClasses(response.data)
    },
    showDate(date) {
      return moment(date).format('M.DD')
    },
    showDay(day) {
      return moment(day).format('ddd')
    },
    openModalSchedule(scheduleId) {
      this.$store.dispatch('modal/openModalMelonTV', scheduleId)
    },
    parseCssVars: parseCssVars
  }
}
</script>
